export const GET_CAREER_INFO = "GET_CAREER_INFO"
export const GET_CAREER_INFO_SUCCESS = "GET_CAREER_INFO_SUCCESS"
export const GET_CAREER_INFO_FAILURE = "GET_CAREER_INFO_FAILURE"
export const EDIT_CAREER_INFO="EDIT_CAREER_INFO";
export const EDIT_CAREER_INFO_SUCCESS="EDIT_CAREER_INFO_SUCCESS";
export const EDIT_CAREER_INFO_FAILURE="EDIT_CAREER_INFO_FAILURE";
export const GET_CAREER_PAGE = "GET_CAREER_PAGE"
export const GET_CAREER_PAGE_SUCCESS = "GET_CAREER_PAGE_SUCCESS"
export const GET_CAREER_PAGE_FAILURE = "GET_CAREER_PAGE_FAILURE"
export const EDIT_CAREER_PAGE="EDIT_CAREER_PAGE";
export const EDIT_CAREER_PAGE_SUCCESS="EDIT_CAREER_PAGE_SUCCESS";
export const EDIT_CAREER_PAGE_FAILURE="EDIT_CAREER_PAGE_FAILURE";
export const GET_CAREER_DEFAULT = "GET_CAREER_DEFAULT"
export const GET_CAREER_DEFAULT_SUCCESS = "GET_CAREER_DEFAULT_SUCCESS"
export const GET_CAREER_DEFAULT_FAILURE = "GET_CAREER_DEFAULT_FAILURE"
